
const checkBookingTempo = async () => {

  const variantIdToCheck = ["32649571401774"];

  const twoHoursInMilliseconds = 0.5 * 60 * 60 * 1000;
  
  const popupBridal = localStorage.getItem(variantIdToCheck[0]);

  console.log("POPUP BRIDAL BOOKING CHECK TEMPO", popupBridal);

  if(popupBridal !== null){
    console.log("FETCH THE CART! ");

    const nowDate = Date.now();
    // If dateNow is bigger than time when booking added to cart + 2 hours
    // We want to remove the booking from the cart

console.log("DATE CHECK : ", nowDate, parseInt(popupBridal) + twoHoursInMilliseconds)
    
    
    if(nowDate > parseInt(popupBridal) + twoHoursInMilliseconds){
      
      const cart = await fetch('/cart.js').then(res => res.json());
      const itemPopupBridal = cart.items.find(item => item.id == variantIdToCheck[0]);

      if(itemPopupBridal !== undefined){

        markBookingAsExpired(itemPopupBridal.properties.Ref, itemPopupBridal.properties.Date)
        
        console.log("itemPopupBridal : ", itemPopupBridal);
        console.log("itemPopupBridal KEY : ", itemPopupBridal.key);
    
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: itemPopupBridal.key,     // key is needed, not product ID
            quantity: 0
          })
        });
      }
    }
      
  }
  
}


const markBookingAsExpired = (ref, date) => {

  const sum = "E6fthGBHJ7867GHJYEH65TH88";
  const base_url = "https://popupbridal.folkster.com";

  console.log("Ref", ref)
  console.log("Date", date)
  
  fetch(base_url + "/index.php/ajax/mark_appointment_expired/", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded", // jQuery uses this by default for form data
      "Accept": "application/json"
    },
    body: new URLSearchParams({
      sum: sum,
      ref: ref,
      date: date
    })
  })
  .then(response => response.json())
  .then(data => {
    console.log("Booking Expired");
  })
  .catch(error => {
    console.error('Error:', error);
  });


  
}

await checkBookingTempo();